export type StatusRole = "success" | "warning" | "error" | "info" | "default";

const ROLE_BY_KEYWORD: Record<string, StatusRole> = {
  paid: "success", posted: "success", active: "success", completed: "success",
  done: "success", approved: "success", closed: "success", ok: "success",
  success: "success", create: "success", post: "success",
  pending: "warning", draft: "warning", waiting: "warning", hold: "warning",
  on_hold: "warning",
  overdue: "error", error: "error", failed: "error", rejected: "error",
  cancelled: "error", canceled: "error", blocked: "error", delete: "error",
  new: "info", open: "info", in_progress: "info", processing: "info",
  update: "info",
};

export function statusToRole(status: string): StatusRole {
  const key = String(status ?? "").trim().toLowerCase();
  return ROLE_BY_KEYWORD[key] ?? "default";
}
